/**
 * 静态资源路径规范
 *
 * 团队文件上传目录：frontend > assets > ka > aspnet
 * CDN 根路径：https://static.huashicloud.com/assets/ka/aspnet
 *
 * 图片需按用途分文件夹存放，与页面/模块对应，便于维护与 CDN 缓存。
 * 上传时在飞牛对应目录下创建以下子目录（无则新建）。
 *
 * @module constants/static-assets
 */

import { getStaticAssetUrl } from '@/env';

/** 静态资源子目录（相对于 assets/ka/aspnet），与团队文件中的 image/ 下分类一致 */
export const STATIC_ASSETS_DIRS = {
  /** 页脚 logo 等，如 unesco-logo.svg */
  footer: 'image/footer',
  /** 页头 logo、导航相关图 */
  header: 'image/header',
  /** 首页用图：Hero、轮播、功能卡片等 */
  home: 'image/home',
  /** 通用/全局：favicon、logo、跨页共用图 */
  global: 'image/global',
  /** 横幅、全站 banner */
  banner: 'image/banner',
  /** 关于我们页 */
  aboutUs: 'image/about-us',
  /** 活动相关页 */
  activity: 'image/activity',
  /** 资料库/课程资源页 */
  database: 'image/database',
  /** 合作伙伴页 */
  partners: 'image/partners',
  /** 会员申请/反馈表单页 */
  feedbackForm: 'image/feedback-form',
  /** 智慧教育平台页 */
  smartEducation: 'image/smart-education-platform',
  /** ICH 专区页 */
  ich: 'image/ich',
} as const;

/**
 * 按分类获取静态资源完整 CDN 地址
 * 始终在路径前加 image/，与飞牛目录 assets/ka/aspnet/image/xxx 一致
 * @param dir - STATIC_ASSETS_DIRS 中的 key 或任意子路径（如 'footer'、'image/footer'）
 * @param filename - 文件名，如 'unesco-logo.png'
 */
export const getAssetUrlByDir = (
  dir: keyof typeof STATIC_ASSETS_DIRS | string,
  filename: string,
): string => {
  const rawPath = typeof dir === 'string' ? dir : STATIC_ASSETS_DIRS[dir];
  const path = rawPath.startsWith('image/') ? rawPath : `image/${rawPath}`;
  const fullPath = `${path.replace(/\/$/, '')}/${filename.replace(/^\//, '')}`;
  return getStaticAssetUrl(fullPath);
};
